import React, { useEffect,useRef,  useState } from 'react';
import {fetchAPIData} from '../Actions/StatCards'
import { useSelector, useDispatch } from 'react-redux';
import { FaAngleDoubleDown } from 'react-icons/fa';
import { FaAngleDoubleUp } from 'react-icons/fa';
import GlobalStats from './Comp_GobalStats';


import { FaArrowUp } from "react-icons/fa";
import Moment from 'react-moment';
import moment from 'moment';
  
function InfoCards() {

const imageref = useRef(null);

const CardData = useSelector(state => state.InfoCardData.cardData); 
 
const TestData =  useSelector(state => state.InfoCardData.tests);
const dispatch = useDispatch();

useEffect(()=>{
   dispatch(fetchAPIData());
    window.addEventListener("scroll", scrollHandler);//add listner whne the cop mounts
   // console.log("in use eff");
    return()=>{
        console.log("Terminated");
        //this is when the listner should be removed.
        window.removeEventListener("scroll",scrollHandler);
    }
},[])

const [inView, setInveiew] = useState(false)
const [viewTestStats, set_viewTestStats] = useState(false)
const [GlobalStatss, set_GlobalStatss] = useState(false)



const isInView = () => {

    if(imageref.current){
        const rect = imageref.current.getBoundingClientRect();
        return rect.top >=0 && rect.bottom <= window.innerHeight;
    }
    return false;
}

const scrollHandler = () => {
    setInveiew(() => {
        return isInView();
    })
}

console.log('dsadsa',CardData);
  return(
   <div>
        {CardData != undefined?
                CardData.cardLoading === true ?
                                 <p>Loading....</p>
                                 :
                                 <div>
         
                                                        <div class="row infocards">    
                                                            <div class="col-md-3">
                                                                <center>
                                                                    <h2 class="totalCaseCardHead">TOTAL</h2>
                                                                </center>
                                                                <center>
                                                                        <p id="total" class="totalCaseContent" style={{color:"#5454b8"}}>
                                                                            { <img src="./increase.png" class="ImgTotalCase"  /> }
                                                                            {parseInt(CardData.confirmed).toLocaleString()}  &nbsp; <b><FaArrowUp />{parseInt(CardData.deltaconfirmed).toLocaleString()}</b></p>
                                                                </center>
                                                                <center> 
                                                                            <p id="total" style={{fontSize:'12px', color:'#5454b8'}} ><b>YESTERDAY {CardData.confirmed - CardData.deltaconfirmed}</b></p>
                                                                </center>
                                                                
                                                            </div>

                                                            <div class="col-md-3">
                                                                <center>
                                                                    <h2 class="ActCardHead">ACTIVE</h2>
                                                                </center>
                                                                <center> 
                                                                        <p id="recovered" class="ActContent"  ><img src="./businesswoman.png" class="ImgActive"  />{parseInt(CardData.active).toLocaleString()}  &nbsp; <b>{CardData.deltaactive}</b></p>
                                                                </center>
                                                                
                                                                    
                                                            </div>

                                                            <div class="col-md-3">
                                                                <center>
                                                                    <h2 class="recCardHead">RECOVERED</h2>
                                                                </center>
                                                                <center> 
                                                                        <p id="recovered" class="recContent" ><img src="./physiotherapy.png" class="ImgRecovered" />{parseInt(CardData.recovered).toLocaleString()}  &nbsp; <b><FaArrowUp />{CardData.deltarecovered}</b></p>
                                                                </center>
                                                                <center> 
                                                                            <p id="recovered" style={{fontSize:'12px', color:'green'}} ><b>YESTERDAY {CardData.recovered - CardData.deltarecovered}</b></p>
                                                                </center>
                                                                
                                                                    
                                                            </div>

                                                                <div class="col-md-3">
                                                                    <center>  
                                                                        <h2 class="deathCardHead" style={{background:"#d3d3d333"}}>DEATHS</h2>
                                                                    </center>
                                                                    <center>
                                                                        <p id="death" class="deathContent" ><img src="./death.png" class="ImgDeath" />{parseInt(CardData.deaths).toLocaleString()}  &nbsp; &nbsp; <b><FaArrowUp />{CardData.deltadeaths}</b></p>
                                                                    </center>
                                                                    <center> 
                                                                            <p id="death" style={{fontSize:'12px', color:'grey'}} ><b>YESTERDAY {CardData.deaths - CardData.deltadeaths}</b></p>
                                                                </center>
                                                                
                                                                
                                                            </div>
                                                            </div> 
                                                                    <div class="row"> 
                                                                        <div class="col-12">
                                                                         <p class="LastUpdatedLabel" style={{color:'grey', float:'right'}}>*Last updated on { <Moment format="LLLL">
                                                                                              {moment(CardData.lastupdatedtime, 'DD-MM-YYYY HH:mm').format()}
                                                                                    </Moment> }.                                            
                                                                         </p>
                                                                         </div>
                                                                    </div>
                                                                    <div class="row"> 
                                                                                    <div style={{marginLeft:'15px'}}>    
                                                                                        <button  onClick={e => set_viewTestStats(!viewTestStats)} class="btn popbtn btn-testStats" >India Test Stats {viewTestStats ?
                                                                                        
                                                                                        <FaAngleDoubleUp />
                                                                                        :
                                                                                        <FaAngleDoubleDown />
                                                                                        }
                                                                                        </button>
                                                                           
                                                                                        &nbsp;
                                                                                        &nbsp;
                                                                                <button  onClick={e => set_GlobalStatss(!GlobalStatss)} class="btn popbtn btn-testStats" >Select Country {GlobalStatss ?
                                                                                <FaAngleDoubleUp />
                                                                                :
                                                                                <FaAngleDoubleDown />
                                                                                }
                                                                                </button>
                                                                                </div>
                                                                    </div>

                                                                {viewTestStats ?

                                                                    <div class="row infocards testStatsDiv" style={{borderColor:"grey"}}>  
                                                                                <div class="col-md-3">
                                                                                    <center>
                                                                                        <h2 class="totalCaseCardHead" style={{color:"rgba(219, 159, 124, 0.95)", background:"#d2a82e36"}}>TODAY</h2>
                                                                                    </center>
                                                                                    <center>
                                                                                            <p id="total" style={{color:"rgba(219, 159, 124, 0.95)"}} class="totalCaseContent">
                                                                                            
                                                                                            {parseInt(TestData.samplereportedtoday).toLocaleString()}  &nbsp; </p>
                                                                                    </center>
                                                                                
                                                                                    
                                                                                </div>

                                                                                <div class="col-md-3">
                                                                                    <center>
                                                                                        <h2 class="totalCaseCardHead" style={{color:"#54a1b8", background:"#7fc1b836"}}>TOTAL</h2>
                                                                                    </center>
                                                                                    <center>
                                                                                            <p id="total" style={{color:"#54a1b8"}} class="totalCaseContent">
                                                                                            
                                                                                            {parseInt(TestData.totalsamplestested).toLocaleString()}  &nbsp; </p>
                                                                                    </center>
                                                                                </div>
                                                                    
                                                                                <div class="col-md-3">
                                                                                        <center>
                                                                                            <h2 class="totalCaseCardHead" style={{color:"#acacf7", background:"#bea9da4a"}}>RECOVERY</h2>
                                                                                        </center>
                                                                                        <center>
                                                                                                <p id="total" style={{color:"#acacf7"}} class="totalCaseContent">
                                                                                                
                                                                                                {parseFloat((CardData.recovered / CardData.confirmed)*100).toFixed(2)}%</p>
                                                                                        </center>                                            
                                                                                </div>
                                                                                
                                                                                <div class="col-md-3">
                                                                                    <center>
                                                                                        <h2 class="totalCaseCardHead" style={{color:"#92b854", background:"#fdf69d36"}}>DEATH</h2>
                                                                                    </center>
                                                                                    <center>
                                                                                            <p id="total" style={{color:"#92b854"}} class="totalCaseContent">
                                                                                            
                                                                                            {parseFloat((CardData.deaths / CardData.confirmed)*100).toFixed(2)}% </p>
                                                                                    </center>
                                                                                
                                                                                    
                                                                                </div>
                                                                        
                                                                    </div>
                                                                    :""
                                                                }


                                                        { GlobalStatss ?     
                                                             <GlobalStats  />                                                                                                        
                                                        :
                                                        ""
                                                        }
                                                        
                                                                       
                                                                                  
                                </div>
        :    
        <center><p class="LoaderMsg">Please wait, Loading............</p></center>
        }           
    </div>
  )
}
export default InfoCards